<ng-container *appTranslate="let t">
  <p-dialog [visible]="visible()" visibleChange="visibleChange.emit($event)">
    <ng-template pTemplate="headless">
      <div class="announcement">
        <div class="background-dots"></div>
        <div class="h-full max-h-full flex flex-column justify-content-between align-items-center">
          <app-new-ankaadia-announcement-header [title]="t('newAnkaadiaAnnouncement.title')" class="w-full" />

          <p-carousel
            [value]="data"
            [page]="activeIndex"
            (onPage)="onPageChange($event)"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="true"
            [autoplayInterval]="10000"
            [style.min-height]="0"
          >
            <ng-template let-data pTemplate="item">
              <img class="section-background" [attr.src]="data.imageSrc" width="100%" />
            </ng-template>
            <ng-template pTemplate="previousicon">
              <img class="section-background galleria-icon" src="/assets/new-ankaadia-announcement/left-arrow.svg" />
            </ng-template>
            <ng-template pTemplate="nexticon">
              <img class="section-background galleria-icon" src="/assets/new-ankaadia-announcement/right-arrow.svg" />
            </ng-template>
          </p-carousel>
          <div class="w-full flex flex-column gap-4">
            <div class="information flex flex-column" [class.fade-out]="isAnimating">
              <div class="title" [innerHtml]="t(data[activeIndex].title) | safe: 'html'"></div>
              <div class="content" [innerHtml]="t(data[activeIndex].body) | safe: 'html'"></div>
            </div>
            <div
              class="button-area flex flex-column lg:flex-row gap-2 lg:gap-4 justify-content-between align-items-stretch"
            >
              <div class="flex flex-column lg:flex-row gap-2 lg:gap-4 align-items-stretch">
                <app-button
                  label="Zu Ankaadia 2.0 wechseln"
                  severity="success"
                  styleClass="w-full lg:w-auto"
                  (click)="openNewAnkaadiaUi($event)"
                >
                  <ng-template pTemplate="icon">
                    <div class="icon switch-icon"></div>
                  </ng-template>
                </app-button>
                <app-button
                  label="Zur Dokumentation"
                  severity="info"
                  styleClass="w-full lg:w-auto"
                  (click)="openDocumentation()"
                >
                  <ng-template pTemplate="icon">
                    <div class="icon documentation-icon"></div>
                  </ng-template>
                </app-button>
              </div>
              <app-button
                label="Schließen"
                severity="secondary"
                (click)="visibleChange.emit(false)"
                styleClass="w-full lg:w-auto"
              >
                <ng-template pTemplate="icon">
                  <div class="icon close-icon"></div>
                </ng-template>
              </app-button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>
  <p-confirmDialog [key]="newAnkaadiaConfirmationKey" />
</ng-container>
